import apiClient from "../../utils/apiClient"; // Adjust path based on your structure


export const CreateOrder = (orderData) => {
  return apiClient.post(`/orders/order/create`, orderData);
}

export const payementCreate = (paymentData) => {
  return apiClient.post(`/orders/order/payments/create`, paymentData);
}

export const getOrderDetails = (orderNumber) => {
  return apiClient.get(`/orders/order/details/${orderNumber}`);
}
